"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inject = inject;
exports.injectable = injectable;
const Druid_1 = require("../../Druid");
function inject(key) {
    return (target, propertyKey, parameterIndex) => {
        if (propertyKey !== undefined) {
            throw new Error(`Only injection into constructor is allowed. You are trying to inject into "${String(propertyKey)}"`);
        }
        Druid_1.default.getContainer().registerInjection(target, { parameterIndex, key });
    };
}
function injectable(injectSettings) {
    return (serviceConstructor) => Druid_1.default.getContainer().registerService(serviceConstructor, injectSettings);
}
//# sourceMappingURL=Inject.js.map